module.exports = __webpack_public_path__ + "img/couples-010.e47f49e8.jpg";